// extracted by mini-css-extract-plugin
export default {"disabledRow":"ArtworksDissociation_disabledRow__q+TaZ","title":"ArtworksDissociation_title__cETx0"};